/**
 * Cap an email image/table to the reader width without letting it grow
 * past the size the sender intended:
 * - the sender's own `max-width` (logos: `width:100%; max-width:156px`);
 * - else the pixel `width` attribute (Outlook sizing next to a fluid
 *   `width:100%` style).
 * Replacing those caps with a bare 100% stretches logos to the full width.
 */
export const capToReaderWidth = (node: HTMLElement) => {
  const senderMax = node.style.getPropertyValue("max-width").trim();
  const ownMax =
    senderMax && !/^(none|100%|initial|inherit|unset)$/i.test(senderMax)
      ? senderMax
      : null;
  const widthAttr = node.getAttribute("width")?.trim() ?? "";
  const attrPx = /^\d+(px)?$/i.test(widthAttr)
    ? Number.parseInt(widthAttr, 10)
    : null;
  const cap = ownMax ?? (attrPx && attrPx > 0 ? `${attrPx}px` : null);
  node.style.setProperty(
    "max-width",
    cap ? `min(100%, ${cap})` : "100%",
    "important",
  );
};
